<mat-card appearance="outlined" id="login-form-card">
  <mat-card-content>
    @if ((bannerStatus$ | async)) {
      <mat-toolbar
        id="login-banner"
        color="{{ bannerColor$ | async }}"
        fxFlexFill
        >
        <span id="login-banner-message">
          {{ bannerMessage$ | async }}
        </span>
      </mat-toolbar>
    }
    <div id="login-form-container">
      <h3>Registration Form for Existing Students</h3>
      @if (courseInviteHash) {
        <p>
          We've detected that you already have an account. To register for
          the class, please click register. After registration you'll be redirected
          to MyCL to log in.
        </p>
      }
      @if (schoolInviteHash) {
        <p>
          We've detected that you already have an account. To register for
          the school, please click register. After registration you'll be redirected
          to MyCL to log in.
        </p>
      }
      <form
        novalidate
        id="login-form"
        [formGroup]="registerForm"
        (ngSubmit)="register()"
        >
        <!--inviteHash-->
        <mat-form-field>
          <input
            id="login-inviteHash"
            matInput
            placeholder="Invite Code"
            formControlName="inviteHash"
            required
            />
          @if (validate('inviteHash', 'required')) {
            <mat-error>
              Invite Code is required
            </mat-error>
          }
        </mat-form-field>
        <button
          id="cancel-button"
          type="button"
          mat-raised-button
          color="secondary"
          (click)="cancel()"
          >
          Cancel
        </button>
        <button
          id="login-button"
          type="submit"
          mat-raised-button
          color="primary"
          >
          Register
        </button>
      </form>
    </div>
  </mat-card-content>
</mat-card>
